import Swal from 'sweetalert2';

// helper reutilizable para success/error/confirm/toast
export async function showAlert(type = 'success', title = '', text = '', opts = {}) {
  const icon = type === 'error' ? 'error' : (type === 'question' ? 'question' : 'success');
  const defaultTitle = title || (type === 'error' ? 'Error' : 'Éxito');

  return Swal.fire({
    icon,
    title: defaultTitle,
    text: opts.html ? undefined : text,
    html: opts.html || undefined,
    target: opts.target || 'body',
    // no forzar posición por defecto; si opts.position existe, úsala
    ...(opts.position ? { position: opts.position } : {}),
    // defaults: para éxito comportarse como el showToast original
    showConfirmButton: opts.showConfirmButton ?? (type === 'success' ? false : true),
    showCloseButton: opts.showCloseButton ?? false,
    timer: opts.timer ?? (type === 'success' ? 2000 : undefined),
    timerProgressBar: opts.timerProgressBar ?? (type === 'success'),
    allowOutsideClick: opts.allowOutsideClick ?? true,
    // no forzar customClass; solo usar si se pasa explícitamente
    ...(opts.customClass ? { customClass: opts.customClass } : {}),
    confirmButtonColor: opts.confirmButtonColor ?? (type === 'error' ? '#99172A' : '#28a745'),
    cancelButtonColor: opts.cancelButtonColor ?? '#6c757d',
  });
}

// helper para confirmaciones (devuelve resultado)
export function confirmAlert(options) {
  return Swal.fire({
    ...options,
    target: options.target || 'body',
    customClass: options.customClass || { popup: 'swal2-center' },
  });
}